import React, { createContext, useState } from 'react'
import { IGetAllDashboardResponse } from 'services/GST/Dashboard'

export interface IPeriodo {
  fim: string
  inicio: string
}

export type TContentReportType = 'geral' | 'itens'
export type TGridsNames = 'listaContrapartes' | 'listaContrapartesSubstituto' | 'listaEmpresas' | 'listaCentros' | 'listaFornecedores'
export type TGraphicType = 'circular' | 'linear'
export type TChecklistNames = 'idContraparte' | 'idContraparteSubstituto' | 'idEmpresa' | 'idCentroPlanta' | 'idFornecedor'
export interface ISelectedItensIds {
  idContraparte: number[],
  idContraparteSubstituto: number[],
  idEmpresa: number[],
  idCentroPlanta: number[],
  idFornecedor: number[],
}

interface IUseDashboard {
  periodo: IPeriodo
  setPeriodo: React.Dispatch<React.SetStateAction<IPeriodo>>
  contentReportType: TContentReportType
  setContentReportType: React.Dispatch<React.SetStateAction<TContentReportType>>
  reportType: TGraphicType
  setReportType: React.Dispatch<React.SetStateAction<TGraphicType>>
  selectedItensOfGrid: ISelectedItensIds
  setSelectedItensOfGrid: React.Dispatch<React.SetStateAction<ISelectedItensIds>>
  lastInteractionGridName: TGridsNames | null
  setLastInteractionGridName: React.Dispatch<React.SetStateAction<TGridsNames | null>>
  unidadeGestoraId: number
  setUnidadeGestoraId: React.Dispatch<React.SetStateAction<number>>
  viewGraphic: boolean
  setViewGraphic: React.Dispatch<React.SetStateAction<boolean>>
  dashboardData: IGetAllDashboardResponse
  setDashboardData: React.Dispatch<React.SetStateAction<IGetAllDashboardResponse>>
}

export const DashboardContext = createContext<IUseDashboard>(null)

export const DashboardProvider: React.FC = ({ children }) => {
  const [contentReportType, setContentReportType] = useState<TContentReportType>('geral')
  const [reportType, setReportType] = useState<TGraphicType>('circular')
  const [lastInteractionGridName, setLastInteractionGridName] = useState<TGridsNames | null>(null)
  const [unidadeGestoraId, setUnidadeGestoraId] = useState<number>()
  const [viewGraphic, setViewGraphic] = useState<boolean>(false)
  const [dashboardData, setDashboardData] = useState<IGetAllDashboardResponse>({
    listaContrapartes: [],
    listaEmpresas: [],
    listaCentros: [],
    listaFornecedores: [],
    listaContrapartesSubstituto: [],
  })
  const [selectedItensOfGrid, setSelectedItensOfGrid] = useState<ISelectedItensIds>({
    idContraparte: [],
    idContraparteSubstituto: [],
    idEmpresa: [],
    idCentroPlanta: [],
    idFornecedor: [],
  })
  const [periodo, setPeriodo] = useState<IPeriodo>({
    inicio: null,
    fim: null,
  })

  return (
    <DashboardContext.Provider
      value={{
        dashboardData,
        setDashboardData,
        viewGraphic,
        setViewGraphic,
        unidadeGestoraId,
        setUnidadeGestoraId,
        lastInteractionGridName,
        setLastInteractionGridName,
        periodo,
        setPeriodo,
        contentReportType,
        setContentReportType,
        reportType,
        setReportType,
        selectedItensOfGrid,
        setSelectedItensOfGrid,
      }}
    >
      {children}
    </DashboardContext.Provider>
  )
}
